export default __webpack_public_path__ + "static/media/small_scoop.ff057463.glb";